import App from "./app";
import initializeSvelteApp from "common/initializeSvelteApp";

console.log("tc-ticketbuyer-profile-dropdown initialize");

initializeSvelteApp({
  component: App,
  target: ".tc-ticketbuyer-profile-dropdown",
  props: (element) => {
    return {
      abbr: element.getAttribute("data-abbr"),
      menu: JSON.parse(element.getAttribute("data-menu")) ?? [],
      strings: JSON.parse(element.getAttribute("data-strings")),
    };
  },
});
